import { gql } from "@apollo/client";

import { elementFragment } from "src/graphql/anti-fraud/fragments/ElementFragment";
import { propertyValueFragment } from "src/graphql/anti-fraud/fragments/PropertyValueFragment";

export const customerSummaryFragment = gql`
  fragment CustomerSummaryFragment on Customer {
    id
    numberOfOpenAlerts
    adminStatus {
      lastModification
    }
    elements {
      ...ElementFragment
    }
    properties {
      ...PropertyValueFragment
    }
  }
  ${elementFragment}
  ${propertyValueFragment}
`;
